import { render } from "./InstructorInvitesCard.vue?vue&type=template&id=5ca582af&scoped=true"
import script from "./InstructorInvitesCard.vue?vue&type=script&lang=js"
export * from "./InstructorInvitesCard.vue?vue&type=script&lang=js"

import "./InstructorInvitesCard.vue?vue&type=style&index=0&id=5ca582af&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca582af"]])

export default __exports__